import { IInitialState } from "./types";

export const initialState: IInitialState = {
  productCategoryId: null,
  productCategory: {
    params: {
      page: 1,
      pageSize: 10,
      allProductCategories: null,
      hasMore: true,
      searchTerm: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  updateProductCategory: {
    data: null,
    loading: false,
    error: null,
  },
  productCategoryById: {
    params: {
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  productsCategories: {
    params: {
      page: 1,
      pageSize: 10,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  productsCategoriesForInfinitySelect: {
    params: {
      page: 1,
      pageSize: 10,
      allProductCategories: null,
      hasMore: true,
      searchTerm: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  deleteProductCategory: {
    data: null,
    loading: false,
    error: null,
  }
};
